module.exports = __webpack_public_path__ + "img/battletrip_section2-1.1c7f110e.jpg";